<div class="header-menu-mobile" *ngIf="isMenuOpen && isMobile" [@widthExpandHeader]="navState">
  <div class="tw-flex tw-justify-center tw-items-center tw-h-full">
    <img class="tw-inline tw-w-full" [src]="myhotel_logo" alt="logo" (error)="setLogo(true)">
  </div>
</div>

<ng-container *ngIf="isMenuOpen && isMobile else headerMenuMobile">
  <ng-container *ngTemplateOutlet="headerMenuMobileOpen"></ng-container>
</ng-container>

<ng-template #headerContent>
  <div class="content_header">
    <div class="menu_mobile" (click)="toggleNavbar()" [hidden]="isMenuOpen">
      <i class="fal fa-bars"></i>
    </div>

    <div class="logo_area before-inline" [hidden]="!isMenuOpen || isMobile">
      <a [routerLink]="['/']">
        <img class="tw-inline" [src]="myhotel_logo" alt="logo" (error)="setLogo(true)">
      </a>
    </div>

    <div class="header_area" [class.menu-mobile-opened]="isMobile && isMenuOpen">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-w-2/3">
          <div class="actions">
            <div class="tw-flex tw-items-center content_name_hotel">
              <div class="tw-w-5/6 sm:tw-w-5/6 md:tw-w-1/2">
                <div class="tw-ml-3">
                  <div class="tw-flex tw-items-center">
                    <div class="tw-w-full">
                      <mh-hotel-finder
                        *ngIf="!waitUpdateCustomer"
                        [currentClient]="hotel"
                        [isCorporative]="true"
                        [currentUser]="currentUser"
                        [currentChain]="chain"
                        [isMobile]="isMobile"
                        [isNavbarCorp]="isCorporative"
                        (updated)="updateCustomer($event)"
                        (isReady)="isReady($event)"
                        ></mh-hotel-finder>
                      <mh-spinner-classic *ngIf="waitUpdateCustomer"></mh-spinner-classic>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tw-w-1/6 sm:tw-w-1/6 md:tw-w-1/2 tw-self-center tw-flex tw-items-center" [hidden]="false">
                <div class="tw-ml-3" [class.tw-ml-5]="!isMobile" *ngIf="is_super_admin">
                  <mh-header-button
                    *ngIf="!waitUpdateCustomer"
                    [currentUser]="currentUser"
                    [userProfile]="userProfile"
                    [availableLanguages]="availableLanguages"
                    [customer]="hotel"
                    [size]="35"
                    [isMobile]="isMobile"
                    [isCorporative]="isCorporative"
                    (updated)="updateCustomer($event)"
                    (isReady)="isReady($event)"
                    [size]="40"
                    ></mh-header-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tw-w-1/3" [hidden]="waitUpdateCustomer">
          <div class="tw-flex tw-flex-row-reverse tw-justify-start tw-items-center tw-h-full">
            <ng-container *ngFor="let type of headersButtons">
              <ng-container *ngIf="(isMobile && (type === 'menu' || type === 'notifications')) || !isMobile">
                 <div class="mx-2" [ngClass]="{'': type === 'menu', 'tw-mb-[38px]': type === 'cases' && hasNoDetectedCases}">
                  <mh-header-button
                    [type]="type"
                    [customer]="hotel"
                    [userProfile]="userProfile"
                    [availableLanguages]="availableLanguages"
                    [currentUser]="currentUser"
                    [currentLanguage]="currentLanguage"
                    [currentLanguageId]="currentLanguageId"
                    [isRetail]="isRetail"
                    [isMobile]="isMobile"
                    [isCorporative]="isCorporative"
                    [detectedCases]="detectedCases"
                    (gaEvent)="ga($event)"
                    (updatedLanguage)="switchLanguage($event)"
                    (createCaseEvent)="openNewModal()"
                    (openMenuEvent)="openMenuHandler($event)"
                    (alertUpdatedForHeader)="alertUpdatedForHeader($event)"
                    [size]="40"
                    >
                  </mh-header-button>
                </div>
              </ng-container>
            </ng-container>
            <!-- icono de alerta de facturación -->
            <i 
              *ngIf="is_super_admin && hasActiveAlert"
              class="far fa-exclamation-triangle tw-text-3xl tw-ml-3"
              [ngClass]="{'tw-text-yellow-400': activeAlertType === 'warning', 'tw-text-red-500': activeAlertType === 'blocking', 'tw-mr-12': headersButtons.includes('cases') && hasNoDetectedCases}"
              [mhTooltip]="('header.invoice_alert_with_message' | translate:{alert: activeAlertMessage}) || ('header.invoice_alert_' + activeAlertType | translate)"
              [width]="'tw-w-fit'">
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #headerMenuMobileOpen>
  <div class="wrapper">
    <ng-container *ngTemplateOutlet="headerContent"></ng-container>
  </div>
</ng-template>

<ng-template #headerMenuMobile>
  <ng-container *ngTemplateOutlet="headerContent"></ng-container>
</ng-template>

<ng-container *ngIf="!waiting">
  <mh-flags></mh-flags>
</ng-container>
